import { PermissionCache } from "./PermissionCache";
import { Service } from "./Service";

export class PermissionCacheService extends Service<PermissionCache>
{
}